function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 22C17.4706 22 22 17.4706 22 12C22 6.53922 17.4608 2 11.9902 2C6.52941 2 2 6.53922 2 12C2 17.4706 6.53922 22 12 22ZM11.9804 16.8824C11.4216 16.8824 11.1275 16.4804 11.1275 15.9118V12.8627H7.91177C7.33333 12.8627 6.93137 12.5588 6.93137 12.0196C6.93137 11.4608 7.31373 11.1471 7.91177 11.1471H11.1275V7.90196C11.1275 7.33333 11.4216 6.93137 11.9804 6.93137C12.5294 6.93137 12.8529 7.31373 12.8529 7.90196V11.1471H16.0784C16.6765 11.1471 17.049 11.4608 17.049 12.0196C17.049 12.5588 16.6569 12.8627 16.0784 12.8627H12.8529V15.9118C12.8529 16.5 12.5294 16.8824 11.9804 16.8824Z",
  fill: "#878793"
});

function SvgIconCloseAddCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseAddCircle);
export default __webpack_public_path__ + "static/media/icon-close-add-circle.4e10087a.svg";
export { ForwardRef as ReactComponent };